'use client'

import { LanguageProvider } from './language'

export default function WebinarLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return <LanguageProvider>{children}</LanguageProvider>
}
